import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';

const ContactPage = () => {
  usePageMeta({
    title: 'お問い合わせ | 株式会社MSK',
    ogTitle: 'お問い合わせ | 株式会社MSK',
    description: 'お気軽にお問い合わせください。株式会社MSKへのご質問・ご相談はこちらからどうぞ。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <ContactHero />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;